import {
	BarChart3,
	Cpu,
	FileText,
	Folder,
	Key,
	Server,
	Shield,
	Sparkles,
	TrendingUp,
	Users,
} from "lucide-react";
import type { ComponentType } from "react";

export type NavItem = {
	name: string;
	href: string;
	icon: ComponentType<{ className?: string }>;
	badge?: number;
};

export type NavSection = {
	title: string;
	items: NavItem[];
};

const workspaceItems: NavSection = {
	title: "Workspace",
	items: [
		{ name: "Overview", href: "/dashboard", icon: BarChart3 },
		{ name: "Projects", href: "/projects", icon: Folder },
		{ name: "Model Connections", href: "/models/manage", icon: Server },
		{ name: "Route Configurations", href: "/route-configs", icon: Cpu },
		{ name: "API Keys", href: "/api-keys", icon: Key },
		{ name: "Playground", href: "/playground", icon: Sparkles },
	],
};

const insightsItems: NavSection = {
	title: "Insights",
	items: [
		{ name: "Usage & Analytics", href: "/analytics", icon: TrendingUp },
		{ name: "Audit Logs", href: "/n-r-ops/audit", icon: FileText },
	],
};

const adminItems: NavSection = {
	title: "Admin",
	items: [
		{ name: "Users", href: "/users", icon: Users },
		{ name: "Provider Templates", href: "/providers", icon: Server },
		{ name: "Audit Logs", href: "/audit", icon: FileText },
	],
};

const opsItems: NavSection = {
	title: "Ops",
	items: [
		{ name: "Dashboard", href: "/n-r-ops/dashboard", icon: Shield },
		{ name: "Users", href: "/n-r-ops/users", icon: Users },
		{ name: "API Keys", href: "/n-r-ops/api-keys", icon: Key },
		{ name: "Projects", href: "/n-r-ops/projects", icon: Folder },
		{ name: "Sessions", href: "/n-r-ops/sessions", icon: Shield },
	],
};

export function getNavSections(role?: string | null): NavSection[] {
	const isSuperAdmin = role === "superAdmin";
	const isAdmin = role === "admin" || isSuperAdmin;

	// Super admins get insights and ops sections (no workspace section)
	if (isSuperAdmin) {
		return [insightsItems, opsItems];
	}

	// Regular users and admins get full workspace and insights
	const sections = [workspaceItems, insightsItems];
	if (isAdmin) sections.push(adminItems);
	return sections;
}
